import { getSnapQuotePartInsights } from '@ui/features/quote-builder/state/endpoints/get-snap-quote-part-insights';
import { MatchFulfilled } from '@ui/features/quote-builder/types/match-fulfilled';
import { MatchPending } from '@ui/features/quote-builder/types/match-pending';
import { MatchRejected } from '@ui/features/quote-builder/types/match-rejected';
import { ExtraReducerBuilder } from '@ui/features/quote-builder/types/shared';
import { QuoteBuilderPartInsightsStateType } from '@ui/features/quote-builder/types/state/part-insights';

function getSnapQuotePartInsightsPending(
  state: QuoteBuilderPartInsightsStateType,
  action: MatchPending<typeof getSnapQuotePartInsights.Types.QueryArg>,
) {
  const { snapQuoteLineUuid } = action.meta.arg.originalArgs;

  if (state[snapQuoteLineUuid]?.loadingPartInsight) {
    // This quote line is already marked as loading, don't add it again
    return;
  }

  state[snapQuoteLineUuid] = {
    loadingPartInsight: true,
    loadingMatchingIdInsight:
      state[snapQuoteLineUuid]?.loadingMatchingIdInsight ?? false,
    partInsights: state[snapQuoteLineUuid]?.partInsights ?? null,
  };
}

function getSnapQuotePartInsightsFulfilled(
  state: QuoteBuilderPartInsightsStateType,
  action: MatchFulfilled<
    typeof getSnapQuotePartInsights.Types.ResultType,
    typeof getSnapQuotePartInsights.Types.QueryArg
  >,
) {
  const { snapQuoteLineUuid, partInsights } = action.payload;

  const existingRecord = state[snapQuoteLineUuid];

  state[snapQuoteLineUuid] = {
    loadingPartInsight: false,
    loadingMatchingIdInsight: existingRecord?.loadingMatchingIdInsight ?? false,
    partInsights,
  };
}

function getSnapQuotePartInsightsRejected(
  state: QuoteBuilderPartInsightsStateType,
  action: MatchRejected<typeof getSnapQuotePartInsights.Types.QueryArg>,
) {
  const { snapQuoteLineUuid } = action.meta.arg.originalArgs;

  const existingRecord = state[snapQuoteLineUuid];

  if (existingRecord) {
    state[snapQuoteLineUuid] = {
      ...existingRecord,
      loadingPartInsight: false,
    };
  }
}

export function getSnapQuotePartInsightsReducer(
  builder: ExtraReducerBuilder<QuoteBuilderPartInsightsStateType>,
) {
  builder.addMatcher(
    getSnapQuotePartInsights.matchPending,
    getSnapQuotePartInsightsPending,
  );
  builder.addMatcher(
    getSnapQuotePartInsights.matchFulfilled,
    getSnapQuotePartInsightsFulfilled,
  );
  builder.addMatcher(
    getSnapQuotePartInsights.matchRejected,
    getSnapQuotePartInsightsRejected,
  );
}
